var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "80px",
    width: "80px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.003 512.003",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M256.001,512.003c-4.882,0-8.828-3.955-8.828-8.828V8.83c0-4.873,3.946-8.828,8.828-8.828 c4.882,0,8.828,3.955,8.828,8.828v494.345C264.829,508.048,260.883,512.003,256.001,512.003"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M256.001,150.072c-66.092,0-129.792-19.677-184.196-56.911c-4.025-2.754-5.049-8.245-2.304-12.27 c2.754-4.008,8.245-5.049,12.27-2.295c51.465,35.213,111.713,53.822,174.23,53.822c4.882,0,8.828,3.955,8.828,8.828 C264.829,146.117,260.883,150.072,256.001,150.072"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M503.174,264.83H8.829c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h494.345 c4.882,0,8.828,3.955,8.828,8.828S508.055,264.83,503.174,264.83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M440.148,429.64c-1.766,0-3.558-0.53-5.111-1.642c-52.551-37.447-114.458-57.238-179.032-57.238 c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828c68.264,0,133.72,20.93,189.272,60.522 c3.972,2.825,4.899,8.333,2.066,12.314C445.621,428.352,442.903,429.64,440.148,429.64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M261.647,511.861c-2.578,0-5.12-1.112-6.868-3.275c-3.072-3.787-2.489-9.348,1.298-12.412 c72.881-59.03,114.679-146.573,114.679-240.172c0-4.873,3.955-8.828,8.828-8.828c4.882,0,8.828,3.955,8.828,8.828 c0,98.957-44.182,191.488-121.212,253.89C265.558,511.216,263.598,511.861,261.647,511.861"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M132.415,264.83c-4.882,0-8.828-3.955-8.828-8.828c0-98.948,44.182-191.488,121.203-253.89 c3.805-3.081,9.348-2.481,12.429,1.306c3.063,3.787,2.481,9.34-1.307,12.412c-72.881,59.03-114.67,146.573-114.67,240.172 C141.243,260.875,137.297,264.83,132.415,264.83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M256.001,512.003c-14.892,0-30.111-1.368-45.224-4.061c-4.802-0.865-7.989-5.447-7.142-10.249 c0.856-4.802,5.455-7.998,10.249-7.133c14.089,2.507,28.266,3.787,42.116,3.787c131.425,0,238.345-106.92,238.345-238.345 c0-30.226-5.65-59.78-16.79-87.843c-1.792-4.529,0.415-9.666,4.943-11.467c4.52-1.792,9.657,0.415,11.467,4.952 c11.961,30.137,18.035,61.89,18.035,94.358C512.001,397.165,397.154,512.003,256.001,512.003"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8697CB"
    },
    d: "M23.174,347.878c-3.628,0-7.027-2.251-8.307-5.862C4.998,314.403,0.001,285.458,0.001,256 c0-141.153,114.847-256,256-256c27.383,0,54.449,4.37,80.463,12.977c4.634,1.536,7.142,6.532,5.605,11.158 c-1.527,4.634-6.515,7.142-11.158,5.606c-24.214-8.015-49.417-12.085-74.911-12.085C124.576,17.655,17.656,124.584,17.656,256 c0,27.427,4.652,54.369,13.824,80.075c1.651,4.599-0.75,9.64-5.341,11.282C25.169,347.71,24.154,347.878,23.174,347.878"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13A085"
    },
    d: "M401.656,0.003c-60.937,0-110.345,44.844-110.345,100.149c0,20.383,6.727,39.336,18.247,55.155 c-1.51,18.282-5.87,44.023-18.247,56.558c0,0,37.835-5.376,63.453-21.045c14.239,6.073,30.129,9.49,46.892,9.49 c60.937,0,110.345-44.844,110.345-100.158C512.001,44.847,462.593,0.003,401.656,0.003"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4482C3"
    },
    d: "M110.346,300.141c60.937,0,110.345,44.844,110.345,100.149c0,20.383-6.727,39.336-18.247,55.155 c1.51,18.282,5.87,44.023,18.247,56.558c0,0-37.835-5.376-63.453-21.045c-14.239,6.073-30.129,9.49-46.892,9.49 c-60.937,0-110.345-44.844-110.345-100.158C0.001,344.985,49.409,300.141,110.346,300.141"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M423.725,70.623h-61.793c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h61.793 c4.882,0,8.828,3.955,8.828,8.828S428.607,70.623,423.725,70.623"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M450.208,141.244h-88.276c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h88.276 c4.882,0,8.828,3.955,8.828,8.828S455.09,141.244,450.208,141.244"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M467.863,105.934H361.932c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828 h105.931c4.882,0,8.828,3.955,8.828,8.828C476.691,101.979,472.745,105.934,467.863,105.934"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M123.588,370.761H61.794c-4.882,0-8.828-3.955-8.828-8.828s3.946-8.828,8.828-8.828h61.793 c4.882,0,8.828,3.955,8.828,8.828S128.469,370.761,123.588,370.761"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.07,441.382H61.794c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828h88.276 c4.882,0,8.828,3.955,8.828,8.828C158.898,437.427,154.952,441.382,150.07,441.382"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.725,406.072H61.794c-4.882,0-8.828-3.955-8.828-8.828c0-4.873,3.946-8.828,8.828-8.828 h105.931c4.882,0,8.828,3.955,8.828,8.828C176.553,402.117,172.607,406.072,167.725,406.072"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4bba606c975ecb017edb1beae42b10be.svg";
export { ForwardRef as ReactComponent };